import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, NgForm } from '@angular/forms';
import { AtopicDermatitisAfterVideo2 } from 'src/app/models/atopic-dermatitis-after-video-2.model';
import { AtopicDermatitisAfterVideo2Service } from 'src/app/services/atopicDermatitisAfterVideo2.service';

@Component({
    selector: 'app-after-question-video-2-popup',
    templateUrl: './after-question-video-2-popup.component.html',
    styleUrls: ['./after-question-video-2-popup.component.scss'],
})
export class AfterQuestionVideo2PopupComponent {
    public atopicDermatitisAfterVideo2: AtopicDermatitisAfterVideo2;

    itemForm = this.fb.group({
        question1: ['', Validators.required],
        question2: ['', Validators.required],
        question3: ['', Validators.required],
        email: [''],
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<AfterQuestionVideo2PopupComponent>,
        private fb: FormBuilder,
        private atopicDermatitisAfterVideo2Service: AtopicDermatitisAfterVideo2Service
    ) {}

    onAtopicDermatitisChange(value) {
        this.itemForm.patchValue({});
    }

    // saveFaq() {
    //     this.faqService.updateFaq(this.faq);
    // }

    submit() {
        // this.isSubmitted = true;
        localStorage.setItem('isSubmitted', 'true');
        const a = { ...this.atopicDermatitisAfterVideo2, ...this.itemForm.value };
        this.atopicDermatitisAfterVideo2Service.saveAtopicDermatitisAfterVideo2(a);
        this.dialogRef.close();
    }

    cancel() {
        this.dialogRef.close();
    }

    submitForm(form: NgForm) {
        // this.isSubmitted = true;
        if (!form.valid) {
            return false;
        } else {
            alert(JSON.stringify(form.value));
        }
        this.dialogRef.close();
    }
}
